export default {
  width: 16,
  height: 17,
  stroke: true,
  svg: `
  <path d="M15 9.57143C15 11.2764 14.2625 12.9115 12.9497 14.1171C11.637 15.3227 9.85652 16 8 16C6.14348 16 4.36301 15.3227 3.05025 14.1171C1.7375 12.9115 1 11.2764 1 9.57143V2.42857L8 1L15 2.42857V9.57143Z" stroke-width="1.5" stroke-miterlimit="10" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M7.20555 9.58827C6.85677 9.98911 6.23414 9.98911 5.88536 9.58827L5.09282 8.67745C4.85164 8.40026 4.42109 8.40026 4.1799 8.67745C3.98176 8.90516 3.98176 9.24409 4.1799 9.47181L5.69676 11.2151C6.1452 11.7304 6.94571 11.7304 7.39415 11.2151L11.8201 6.12852C12.0182 5.90081 12.0182 5.56188 11.8201 5.33416C11.5789 5.05698 11.1484 5.05698 10.9072 5.33416L7.20555 9.58827Z" stroke-width="0.25"/>
  `
}
